// extracted by mini-css-extract-plugin
export default {"root":"TextBox_root__iEM3v","inputWrapper":"TextBox_inputWrapper__ChjLw","full":"TextBox_full__QXCYM","visuallyHidden":"TextBox_visuallyHidden__P1G33"};